import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LITERALS } from 'src/app/core/constants/literals.constant';
import { SearchService } from 'src/app/core/services/search.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
import { SuccessMessageComponent } from '../../all-modals/success-message/success-message.component';
@Component({
  selector: 'app-connection-cancel-modal',
  templateUrl: './connection-cancel-modal.component.html',
  styleUrls: ['./connection-cancel-modal.component.scss']
})
export class ConnectionCancelModalComponent implements OnInit {
  imagePath: any;

  constructor(
    private activeModal: NgbActiveModal,
    private _searchService: SearchService,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal
  ) { }
  @Input() public connection;

  ngOnInit() {
    this.imagePath = environment.url;
  }
  closeDialog() {
    this.activeModal.close();
  }

  removeConnection() {
    if (this.connection) {
      if (this.connection.connection_id) {
        this.spinner.show();
        this._searchService.cancelSentRequest(this.connection.connection_id).subscribe(
          (response: any) => {
            this.spinner.hide();
            if (response.success) {
              this.activeModal.close('success');
              // COMMENTED BECAUSE WE DON'T NEED CONNECTION MODAL FOR NOW
              // const modelRef = this.modalService.open(SuccessMessageComponent, { centered: true });
              // modelRef.componentInstance.message = LITERALS.AUTH.SUCCESS_MESSAGES.REQUEST_CANCEL_SUCCESS;
            } else {
              this.activeModal.close('fail');
            }
          }, (error: any) => {
            this.spinner.hide();
            this.activeModal.close('falilure');
          });
      } else if (this.connection.supp_connection_details && this.connection.supp_connection_details.supplementary_connection_id) {
        this.spinner.show();
        this._searchService.cancelSentSaRequest(this.connection.supp_connection_details.supplementary_connection_id).subscribe(
          (response: any) => {
            this.spinner.hide();
            if (response.success) {
              this.activeModal.close('success');
              const modelRef = this.modalService.open(SuccessMessageComponent, { centered: true });
              modelRef.componentInstance.message = LITERALS.AUTH.SUCCESS_MESSAGES.REQUEST_CANCEL_SUCCESS;
            } else {
              this.activeModal.close('fail');
            }
          }, (error: any) => {
            this.spinner.hide();
            this.activeModal.close('falilure');
          });
      } else {
        this.activeModal.close('falilure');
      }
    }
  }
}
